var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.7,
    height: 16,
    viewBox: "0 0 17.7 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1640.491-909.525a.5.5,0,0,1-.208-.046.5.5,0,0,1-.292-.459l.02-2.029h-1.158a1.65,1.65,0,0,1-1.648-1.648v-8.733a1.65,1.65,0,0,1,1.648-1.648H1650.9a1.65,1.65,0,0,1,1.648,1.648v8.733a1.65,1.65,0,0,1-1.648,1.648h-7.334l-2.744,2.41A.5.5,0,0,1,1640.491-909.525Zm-1.637-13.563a.649.649,0,0,0-.648.648v8.733a.649.649,0,0,0,.648.648h1.663a.5.5,0,0,1,.355.148.5.5,0,0,1,.145.357l-.014,1.415,2.045-1.8a.5.5,0,0,1,.33-.124h7.522a.649.649,0,0,0,.648-.648v-8.733a.649.649,0,0,0-.648-.648Z",
    transform: "translate(-1637.706 923.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1685.424-896.055a.5.5,0,0,1-.33-.124l-2.744-2.41h-6.805a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.994a.5.5,0,0,1,.33.124l2.045,1.8-.014-1.415a.5.5,0,0,1,.145-.357.5.5,0,0,1,.355-.148h1.663a.649.649,0,0,0,.648-.648v-8.733a.649.649,0,0,0-.648-.648h-1.073a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.073a1.65,1.65,0,0,1,1.648,1.648v8.733a1.65,1.65,0,0,1-1.648,1.648H1685.9l.02,2.03a.5.5,0,0,1-.292.459A.5.5,0,0,1,1685.424-896.055Z",
    transform: "translate(-1671.509 911.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M1658.193-919.353h9.975v9.975h-9.975Z",
    transform: "translate(-1656.008 919.805)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M1676.954-902.517a4.758,4.758,0,0,1-1.467-.233.406.406,0,0,0-.42.1l-.652.819a6.31,6.31,0,0,1-2.864-2.839l.81-.69a.423.423,0,0,0,.1-.424,4.64,4.64,0,0,1-.233-1.467.415.415,0,0,0-.411-.411h-1.438c-.224,0-.494.1-.494.411a7.128,7.128,0,0,0,7.07,7.07.436.436,0,0,0,.414-.456c0-.011,0-.023,0-.034v-1.434A.416.416,0,0,0,1676.954-902.517Z",
    transform: "translate(-1666.452 909.36)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.263d36b0533147b3550be8acd39670b3.svg";
export { ForwardRef as ReactComponent };